import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router';
import { App } from './app.js';
import { AuthGate } from './auth/gate.js';
import { SessionProvider } from './auth/session.js';
import './tokens.css';

const root = document.getElementById('root');
if (!root) throw new Error('Chyba koreňový element #root.');

createRoot(root).render(
  <StrictMode>
    <BrowserRouter>
      <SessionProvider>
        <AuthGate>
          <App />
        </AuthGate>
      </SessionProvider>
    </BrowserRouter>
  </StrictMode>,
);
